import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrowdown",
  "use": "icon-arrowdown-usage",
  "viewBox": "0 0 1536 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1536 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrowdown\"><path d=\"M768.045254 1024L0 255.954746 256.135761 0l511.909493 512.090507L1279.954746 0l256.135761 255.954746z\" fill=\"currentColor\" p-id=\"1832\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol